module.exports = __webpack_public_path__ + "static/media/Decisions_Step2_Image23.bccf8e02.jpg";